import { Disclosure } from "@headlessui/react";

import * as Track from "@qoohoo/common/utils/analytics/track";
import { button, link, pageview } from "@qoohoo/common/constants/analytics";
import { getMailToLink } from "@qoohoo/common/utils/url";
import useSessionStore from "../../../store/sessionStore";
import FAQ from "../../FAQ";
import cls from "classnames";

const qoohooSupportMail = "support@qoohoo.in";

export default function FAQSection({ channelDetails, isWhiteTheme, customConfig }) {
  const userData = useSessionStore((state) => state.userData);
  const telegramChannelType = channelDetails.telegram?.telegram_chat_type;

  let faqs = [
    {
      q: "When will I get link to join the Telegram after my payment?",
      a: "You will receive your unique link to join on your mobile number instantly. However, in some cases, it may take up to 2 hours to receive the link.",
    },
  ];

  const customConfigForFAQs  = customConfig?.faqs;
  if (customConfigForFAQs) {
    faqs = [
      ...faqs,
      ...customConfigForFAQs
    ];
  }

  const mailSubject = `Query regarding telegram payment`;
  const mailBody = `Hi qoohoo team,
Please look into the issue regarding Telegram ${telegramChannelType}.

What is your query? Write below:

From: 
Name: ${userData.name || ""}
Username: ${userData.username || ""} 
Phone: ${userData.mobile || ""}
Telegram ${telegramChannelType}: ${channelDetails.name}
Page link: ${channelDetails.short_url_flutter}
`;

  const trackingDetails = {
    current_screen: pageview.channel_details,
    is_telegram: true,
  };

  return (
    <section className=" px-5 pt-14 pb-24 sm:pt-24 sm:pb-40 sm:px-20 font-nunito">
      <h2 className="w-full text-2xl font-bold text-center sm:text-4xl md:text-5xl font-inter leading-[140%] dark:text-[#16191B]">
        FAQs
      </h2>
      <div className="max-w-[630px] mx-auto text-[#DBDBDB] mt-10 space-y-6 w-full md:flex md:flex-col items-center justify-center">
        <FAQ
          faqs={faqs}
          {...trackingDetails}
          defaultOpen={true}
          fullWidth={true}
          userData={userData}
          pageUrl={channelDetails.short_url_flutter}
          isWhiteTheme={isWhiteTheme}
        />
      </div>
      <SupportMailSection
        className="max-w-[582px] mt-12 mx-auto text-center dark:text-[#16191B]"
        description={customConfig ?
          "If you need any technical help, write to us at" :
          "If you need any help, please write to us at"}
        mailId={qoohooSupportMail}
        mailSubject={mailSubject}
        mailBody={mailBody}
        onClick={({mailToLink}) => {
          Track.linkClick(link.support, {
            current_screen: pageview.channel_details,
            is_telegram: true,
            url: mailToLink,
          });
        }}
      />
    </section>
  );
}

export function SupportMailSection({className, description, mailId, mailSubject, mailBody, onClick}) {
 const mailToLink = getMailToLink(mailId, mailSubject, mailBody);

 return (
   <p className={className}>
     {description}{" "}
     <a
       href={mailToLink}
       className="underline"
       onClick={onClick ? onClick({mailToLink}) : null}
     >
       {mailId}
     </a>
   </p>
 );
}